import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=11f215ec&"
import script from "./DeleteBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports